import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { RIVER_ICE, RIVER_ICE_VECTOR } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'

export class RiverIce extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const id = 'riverIceLayerId'
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''

    if (!visible) {
      return null
    }

    const rasterSource = {
      type: 'raster',
      tiles: [RIVER_ICE({ idToken, timeIso })],
      tileSize: 256
    }

    return (
      <div>
        <Source id='riverIceSourceId' tileJsonSource={rasterSource} />
        <Layer
          type='raster'
          id='riverIceLayerId'
          sourceId='riverIceSourceId'
          layout={{ visibility: visible ? 'visible' : 'none' }}
          paint={paint}
        />
      </div>
    )
  }
}

export const RiverIceVector = ({ idToken }) => {
  const vectorSource = {
    type: 'vector',
    tiles: [RIVER_ICE_VECTOR(idToken)],
    tileSize: 512
  }
  return (
    <div>
      <Source id='vectorSourceId' tileJsonSource={vectorSource} />
      <Layer
        type='fill'
        id='riverIceVectorId'
        sourceId='vectorSourceId'
        layerOptions={{ 'source-layer': 'RiverIce' }}
        paint={{
          'fill-color': 'black',
          'fill-opacity': 0.7
        }}
      />
    </div>
  )
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, 'RiverIce'),
      paint: getPaint(state, 'RiverIce'),
      time: state.layer.times.RiverIce || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(RiverIce)



// WEBPACK FOOTER //
// ./src/layers/RiverIce.js